<script>
	import UISection from "../ui/UISection.svelte";
	import UIBreadcrumb from "../ui/UIBreadcrumb.svelte";
	import UITitle from "../ui/UITitle.svelte";
	import UIContact from "../ui/UIContact.svelte";
	import UICover from "../ui/UICover.svelte";
	import router from "../stores/router";
	import base from "../stores/base";

	let title = "";
	$: {
		let item = $base.menu.filter((item) => item.url === $router.path)[0];
		title = item ? item.label[$base.lang] : "";
		router.track(title);
	}

	const API = process.env.APP_API;
	let item = null;
	fetch(API + "/home/detail")
		.then((res) => {
			return res.json();
		})
		.then((json) => {
			if (json.message) {
				console.log("----", json.message);
			} else {
				item = json;
			}
		})
		.catch((e) => {
			console.log("----error", e);
		});
</script>

<main>
	<UICover image={$base.contactCover}>
		<UITitle>{title}</UITitle>
	</UICover>

	{#if item}
		<UISection>
			<UIContact body={item["contactDescription_" + $base.lang]} />
		</UISection>
	{/if}
	<UIBreadcrumb bottom />
</main>
